import React, { useState } from "react";
import { Button, Modal, Tooltip, Row, Tag, Space } from "antd";
import {
  UserAddOutlined,
  InfoOutlined,
  InfoCircleTwoTone
} from "@ant-design/icons";
import { appTypeSelector, sebConfigFileLoadingSelector } from "App/OfflineApp/offlineAppSelectors";
import { useSelector, useDispatch } from "react-redux";
import {actions as loginActions} from "views/Auth/Login/redux"
import SEBStartAlternativeModal from "views/Experiences/SEBStartAlternativeModal";
import { openUrl, getOS, getDeviceInfo, checkMob } from "lib/utils/helperMethods";
import MrTranslate, { useTranslate } from "lib/MrTranslate/MrTranslate";

const StartInSebBtn = (props) => {
  // actually now startInApp button = only showing when offline test and appType = "web"
  const {item, disabled} = props;
  console.log("StartInSebBtn props", props);
  const dispatch = useDispatch()
  const mrIntl = useTranslate()
  const sebConfigFileLoading = useSelector(sebConfigFileLoadingSelector())
  const appType = useSelector(appTypeSelector())
  let showBtn = false;

  let startInSEBBtn = <Button shape="round" type="primary" disabled={disabled || sebConfigFileLoading} loading={sebConfigFileLoading} onClick={() => {
    if(sebConfigFileLoading){
      return
    }
    dispatch(loginActions.sebConfigFile({ subject_label: item.custom_fields.subject_item_label }, {successCallback: openUrl}))
  }}>
    {mrIntl("StartInSebBtn.start_in_seb")}
  </Button>

  let startInMacAppBtn = <Tooltip title={mrIntl("StartInSebBtn.make_sure_app_is_installed")}><Button shape="round" type="primary" onClick={() => {
    const webBaseUrl = process.env.REACT_APP_WEB_URL
    let urlWithoutProtocol = webBaseUrl.split("https://")[1]
    let expUrl = `assessprep://${urlWithoutProtocol}`
    // if(item){
    //   expUrl += `/e/tests/${item.uid}?firstLoad=true`
    // }
    // alert(expUrl)
    // window.location.href = expUrl
    openUrl(expUrl)
  }}>
    {mrIntl("StartInSebBtn.start_in_ap_mac")}
  </Button></Tooltip>

  // DONE: if on MAC OS, then open our mac app - open url -> assessprep://app.assessprep.com/e/:uid <- full test url for student
  // assessprep://app-staging.assessprep.com/e/tests/01ET82AAPBJ8WH6V3TEX37RGXR/

  let startInIOSAppBtn = <Tooltip title={mrIntl("StartInSebBtn.open_this_test_ios_app")}><Button shape="round" type="primary" disabled onClick={() => {
    // const webBaseUrl = process.env.REACT_APP_WEB_URL
    // let urlWithoutProtocol = webBaseUrl.split("https://")[1]
    // let expUrl = `assessprep://${urlWithoutProtocol}`
    // openUrl(expUrl)
  }}>
    {mrIntl("StartInSebBtn.start_in_ap_ios")}
  </Button></Tooltip>

  let startInChromebookBtn = <Tooltip title={mrIntl("StartInSebBtn.this_operating_system_is_not_supported")}><Button shape="round" type="primary" disabled>
    {/* Start in App */}
    {mrIntl("StartInSebBtn.start_in_app")}
  </Button></Tooltip>

  let notSupportedBtn = <Tooltip title={mrIntl("StartInSebBtn.this_operating_system_is_not_supported")}><Button shape="round" type="primary" disabled>
    {/* Start in App */}
    {mrIntl("StartInSebBtn.start_in_app")}
  </Button></Tooltip>

 
  let startBtnToRender = []
  // const os = getOS()
  const deviceInfo = getDeviceInfo(appType)
  const os = deviceInfo.os
  if(os === "Mac OS"){
    // startBtnToRender.push(startInSEBBtn) // no need now
    startBtnToRender.push(startInMacAppBtn)
  }else if(os == "Windows"){
    startBtnToRender.push(startInSEBBtn)
  }
  else if(os == "IOS" && !checkMob()){ // appType web but os = IOS - should have start in app button. for now, not showing on iphone, only ipad
    startBtnToRender.push(startInIOSAppBtn)
  }else if(os == "ChromeOS"){
    startBtnToRender.push(startInChromebookBtn)
  }
  else{ // appType web but os where no lockdown app support = android, linux etc
    startBtnToRender.push(notSupportedBtn)
  }


  return <Space>{startBtnToRender}</Space>
};

export default StartInSebBtn;
